import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import './Carousel.scss';
import vars from '../vars.scss';

const Carousel = ({
  items,
  visibleItemsBreakPoints = {
    [`${vars.firstBreakPoint}`]: 3,
    [`${vars.secondBreakPoint}`]: 2,
    '0px': 1,
  },
}) => {
  const [carouselItems, setCarouselItems] = useState([]); // Start with original items
  const [tmpIndex, setTmpIndex] = useState(1);
  const [absoluteIndex, setAbsoluteIndex] = useState(1);
  const [carouselWidth, setCarouselWidth] = useState(0);
  const lastTransitionDirection = useRef(null);
  const [visibleItemsCount, setVisibleItemsCount] = useState(3); // Default to 3 for larger screens
  
  // Get the appropriate number of visible items based on window width
  const getVisibleItemsForWidth = (width) => {
    // Hard-coded values from vars.scss
    if (width >= 1200) { // firstBreakPoint
      return 3;
    } else if (width >= 725) { // secondBreakPoint
      return 2;
    } else {
      return 1;
    }
  };
  
  // Track window resize to update carousel width and visible items
  useEffect(() => {
    const handleResize = () => {
      const carouselElement = document.querySelector('.carousel');
      if (carouselElement) {
        const width = carouselElement.getBoundingClientRect().width;
        setCarouselWidth(width);
        
        // Update visible items count based on window width
        const windowWidth = window.innerWidth;
        const newCount = getVisibleItemsForWidth(windowWidth);
        if (newCount !== visibleItemsCount) {
          setVisibleItemsCount(newCount);
        }
      }
    };
    
    // Initial measurement
    handleResize();
    
    // Listen for resize events
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [visibleItemsCount]);
  
  // Initialize carousel items when visible items count changes
  useEffect(() => {
    if (items.length > 0) {
      setCarouselItems([
        items[items.length - 1],
        ...items.slice(0, visibleItemsCount),
        items[visibleItemsCount % items.length],
      ]);
    }
  }, [visibleItemsCount, items]);

  const gapPx = 12;

  // Handle next slide
  const nextSlide = () => {
    // Dynamically add new item to the end when reaching the last visible item
    lastTransitionDirection.current = 'right';
    setTmpIndex((prev) => prev + 1);
    setAbsoluteIndex((prev) => prev + 1);
  };

  // Handle previous slide
  const prevSlide = () => {
    // Dynamically add new items to the start when reaching the first item
    lastTransitionDirection.current = 'left';
    setTmpIndex((prev) => prev - 1);
    setAbsoluteIndex((prev) => prev - 1);
  };

  useEffect(() => {
    if (tmpIndex === 1) {
      setTimeout(() => {
        document.querySelector('.carousel-wrapper').style.transition =
          'left .5s ease-in-out';
      }, 75);
    }
  }, [tmpIndex]);

  const carouselWrapperWidthPx =
    carouselWidth - (visibleItemsCount - 1) * gapPx;
  const itemWidthPx = carouselWrapperWidthPx / visibleItemsCount;

  return (
    <div className="carousel">
      {/* Left Button */}
      <button className="carousel-button left" onClick={prevSlide}>
        ◀
      </button>

      {/* Items Wrapper */}
      <div
        className="carousel-wrapper"
        style={{
          width: `calc(100% + 1000px)`,
          position: 'relative',
          transition: 'none',
          left: `-${tmpIndex * itemWidthPx + tmpIndex * gapPx}px`,
        }}
        // 5 [1 , 2, 3,] 4
        // 1, [2,3,4], 5
        onTransitionEnd={() => {
          if (tmpIndex === 1) {
            return;
          }
          if (lastTransitionDirection.current === 'right') {
            const positiveMod =
              (((absoluteIndex + visibleItemsCount - 1) % items.length) +
                items.length) %
              items.length;
            setCarouselItems((prevItems) => {
              const res = [...prevItems.slice(1), items[positiveMod]];
              console.log('setCarouselItems', res);
              return res;
            });
            document.querySelector('.carousel-wrapper').style.transition =
              'none';
            setTmpIndex(1);
          } else if (lastTransitionDirection.current === 'left') {
            const positiveMod =
              (((absoluteIndex - 2) % items.length) + items.length) %
              items.length;
            setCarouselItems((prevItems) => [
              items[positiveMod],
              ...prevItems.slice(0, -1),
            ]);
            document.querySelector('.carousel-wrapper').style.transition =
              'none';
            setTmpIndex(1);
          }
        }}
      >
        {carouselItems.slice(0, visibleItemsCount + 2).map((item, i) => (
          <div
            key={i}
            className="carousel-item"
            style={{
              width: `${itemWidthPx}px`,
              //margin: `0 ${index + 1 === i ? '10px' : '0px'}`,
            }}
          >
            {item.content}
          </div>
        ))}
      </div>

      {/* Right Button */}
      <button className="carousel-button right" onClick={nextSlide}>
        ▶
      </button>
    </div>
  );
};

export default Carousel;
